import React from 'react'
import styled from 'styled-components'
import banios from '../../../../../assets/img/banio.png'
import tv from '../../../../../assets/img/tv.png'
import escaleras from '../../../../../assets/img/escaleras.png'

const ContainerCircle = styled.div<{ icon: string | number | null, text: string | number | null }>`
  width: 35px;
  height: 35px;
  border-radius: 50%;
  background: ${p => (p.icon===null && p.text===null) ? 'transparent' : (p.icon!==null) ? p.theme.palette.text.grayLight : 'white'};
  padding: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 8px;
  margin-bottom: 8px;
  cursor: ${p => (p.icon===null && p.text===null) ? 'normal' : (p.icon!==null) ? 'normal' : 'pointer'};

  > img {
    width: 15px;
  }

  :hover{
    background: ${p => (p.text===null) ? '' : '#1EDE91'};
  }
`

interface IOwnProps{
  icon: string | number | null
  text: string | number | null
}

const CircleItem: React.FunctionComponent<IOwnProps> = ({ icon, text }) => {
  const image = (icon === 'banios') ? banios : (icon === 'tv') ? tv : escaleras 
  return (
    <ContainerCircle icon={icon} text={text}>
      {icon !== null && <img src={image} alt='feature' /> }
      {text !== null && (typeof text === 'number') && <p>{text}</p>}
    </ContainerCircle>
  )
}

export default CircleItem